import { RouteRecordRaw } from "vue-router";

const branchesSales: RouteRecordRaw = {
  path: "branchesSales",
  component: () => import("@/views/reports/index.vue"),
  meta: {
    title: "تقرير المبيعات",
  },
  children: [
    {
      path: "",
      alias: "index",
      name: "index-branchesSales",
      component: () => import("@/views/reports/branchesSales/pages/index.vue"),
      meta: {
        pageId: 18010400,
        role: "view",
        title: "تقرير المبيعات",
      },
    },
  ],
};

export default branchesSales;
